import type { LayoutLoad } from './$types';
			import type { CategoryData } from '$lib/metadataTypes/MetaTypes';
			
			export const load: LayoutLoad = async ({ parent }): Promise<CategoryData> => {
				const { site } = await parent(); // parent() = SiteData
				return {
					site,
					category: {
							title: "Freon Demo — Experience the Projectional Editor Online",
description: "Try Freon directly in your browser and explore its web-based projectional editor for building and editing domain-specific languages interactively.",
tags: [ "demo", "interactive", "projectional editor", "web editor", "DSLs", "Freon", "TypeScript", "Svelte"] 
					}
				};
			};